import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAuth } from 'react-oidc-context';
import conf from 'src/conf/conf';
import { selectUserInfoLoaded, selectIsEktacoUser } from 'src/store/selectors/userInfo';
import { selectDayjsLocale } from 'src/store/selectors/translationSelectors';
// Widgeti loader loeb data-* atribuudid oma script-tagilt ainult üks kord laadimisel,
// seega süstime skripti üks kord lehe eluea jooksul (cleanup'i pole — widgetit ei saa
// eemaldada ja logout teeb täisnavigatsiooni). Sellest ka see, et data-lang jääb
// süstimise hetke keele peale: hilisem UI keelevahetus rakendub järgmisel lehe laadimisel.
// Ektaco-kasutaja piirang (isEktacoUser) on katsetusfaasi jaoks — klientidele avamisel
// see guard eemaldatakse.
let injected = false;
export default function useChatWidget() {
    const auth = useAuth();
    const userInfoLoaded = useSelector(selectUserInfoLoaded);
    const isEktacoUser = useSelector(selectIsEktacoUser);
    const locale = useSelector(selectDayjsLocale);
    useEffect(() => {
        const { chatWidgetUrl, chatWidgetId } = conf;
        if (injected
            || window.__bilboWidgetLoaded
            || !auth.isAuthenticated
            || !userInfoLoaded
            || !isEktacoUser
            || !chatWidgetUrl
            || !chatWidgetId) {
            return;
        }
        injected = true;
        const script = document.createElement('script');
        script.src = chatWidgetUrl;
        script.dataset.widgetId = chatWidgetId;
        script.dataset.lang = locale;
        script.async = true;
        script.onerror = () => {
            // Võrgutõrke korral luba uus katse järgmisel effect'i käivitumisel.
            script.remove();
            injected = false;
        };
        document.body.appendChild(script);
    }, [auth.isAuthenticated, userInfoLoaded, isEktacoUser, locale]);
}
